'use strict';exports.__esModule = true;exports.getSimilarProperties = exports.toggleSummaryTranslation = exports.detectSummaryLanguage = exports.translateSummary = exports.deleteMessageAction = exports.upsertMessageAction = exports.sendProjectContactUsForm = exports.setPreloadData = exports.reportProperty = exports.detectDescriptionLanguage = exports.toggleDescriptionTranslation = exports.resetDescriptionTranslate = exports.translateDescription = exports.hidePreviewDetailsPopup = exports.openPreviewDetailsPopup = exports.hideModalContacts = exports.openModalContacts = exports.changeLightboxActiveSlide = exports.hideLightbox = exports.openLightbox = exports.receiveProperty = exports.hideDetailsPopup = exports.openDetailsPopup = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);

var _services = require('../../services');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}var

promise = _reduxLoop.Effects.promise;

var openDetailsPopup = (0, _reduxAct.createAction)('/OPEN_DETAILS');
var hideDetailsPopup = (0, _reduxAct.createAction)('/HIDE_DETAILS');
var openPreviewDetailsPopup = (0, _reduxAct.createAction)('/OPEN_PREVIEW');
var hidePreviewDetailsPopup = (0, _reduxAct.createAction)('/HIDE_PREVIEW');
var openLightbox = (0, _reduxAct.createAction)('/OPEN_LIGHTBOX');
var hideLightbox = (0, _reduxAct.createAction)('/HIDE_LIGHTBOX');
var changeLightboxActiveSlide = (0, _reduxAct.createAction)('/CHANGE_LIGHTBOX_ACTIVE_SLIDE');
var openModalContacts = (0, _reduxAct.createAction)('/OPEN_MODAL_CONTACTS');
var hideModalContacts = (0, _reduxAct.createAction)('/HIDE_MODAL_CONTACTS');
var receiveProperty = (0, _reduxAct.createAction)('/RECEIVE_PROPERTY');
var receivePropertySuccess = (0, _reduxAct.createAction)('/RECEIVE_PROPERTY_SUCCESS');
var receivePropertyFail = (0, _reduxAct.createAction)('/RECEIVE_PROPERTY_FAIL');
var translateDescription = (0, _reduxAct.createAction)('/TRANSLATE_DESCRIPTION');
var translateDescriptionSuccess = (0, _reduxAct.createAction)('/TRANSLATE_DESCRIPTION_SUCCESS');
var translateDescriptionFail = (0, _reduxAct.createAction)('/TRANSLATE_DESCRIPTION_FAIL');
var resetDescriptionTranslate = (0, _reduxAct.createAction)('/RESET_DESCRIPTION_TRANSLATION');
var toggleDescriptionTranslation = (0, _reduxAct.createAction)('/TOGGLE_DESCRIPTION_TRANSLATION');
var detectDescriptionLanguage = (0, _reduxAct.createAction)('/DETECT_DESCRIPTION_LANGUAGE');
var detectDescriptionLanguageSuccess = (0, _reduxAct.createAction)('/DETECT_DESCRIPTION_LANGUAGE_SUCCESS');
var reportProperty = (0, _reduxAct.createAction)('/REPORT_PROPERTY');
var reportPropertySuccess = (0, _reduxAct.createAction)('/REPORT_PROPERTY_SUCCESS');
var reportPropertyFail = (0, _reduxAct.createAction)('/REPORT_PROPERTY_FAIL');
var setPreloadData = (0, _reduxAct.createAction)('/SET_PRELOAD_DATA');
var sendProjectContactUsForm = (0, _reduxAct.createAction)('/SEND_PROJECT_CONTACT_US');
var sendProjectContactUsFormSuccess = (0, _reduxAct.createAction)('/SEND_PROJECT_CONTACT_US_SUCCESS');
var sendProjectContactUsFormFail = (0, _reduxAct.createAction)('/SEND_PROJECT_CONTACT_US_FAIL');

var getSimilarProperties = (0, _reduxAct.createAction)('/GET_SIMILAR_PROPERTIES');
var getSimilarPropertiesSuccess = (0, _reduxAct.createAction)('/GET_SIMILAR_PROPERTIES_SUCCESS');
var getSimilarPropertiesFail = (0, _reduxAct.createAction)('/GET_SIMILAR_PROPERTIES_FAIL');

var upsertMessageAction = (0, _reduxAct.createAction)('/UPSERT_MESSAGE_ACTION');
var deleteMessageAction = (0, _reduxAct.createAction)('/DELETE_MESSAGE_ACTION');
var messageActionSuccess = (0, _reduxAct.createAction)('/MESSAGE_ACTION_SUCCESS');
var messageActionFail = (0, _reduxAct.createAction)('/MESSAGE_ACTION_FAIL');

var translateSummary = (0, _reduxAct.createAction)('/TRANSLATE_TEXT');
var translateSummarySuccess = (0, _reduxAct.createAction)('/TRANSLATE_TEXT_SUCCESS');
var translateSummaryFail = (0, _reduxAct.createAction)('/TRANSLATE_TEXT_FAIL');
var toggleSummaryTranslation = (0, _reduxAct.createAction)('/TOGGLE_TEXT_TRANSLATION');
var detectSummaryLanguage = (0, _reduxAct.createAction)('/DETECT_LANGUAGE');
var detectSummaryLanguageSuccess = (0, _reduxAct.createAction)('/DETECT_LANGUAGE_SUCCESS');

var initialState = {
  isDetailsModalOpen: false,
  propertyId: null,
  loading: false,
  loaded: false,
  similarProperties: null,
  isLightboxOpen: false,
  currentImage: null,
  isModalContactsOpen: false,
  preloadData: null,
  isPreview: false,
  translatedDescriptionRequired: null,
  descriptionLoaded: false,
  showOriginalDescription: false,
  translatedDescriptionText: null,
  targetDescriptionLanguage: null,
  sourceDescriptionLanguage: null,
  reportSending: false,
  reportSendingError: null,
  messageSubmitting: false,
  messages: [],
  translatedSummaryRequired: null,
  summaryLoaded: false,
  showOriginalSummary: false,
  translatedSummaryText: null,
  targetSummaryLanguage: null,
  sourceSummaryLanguage: null };


var fetchReceive = function fetchReceive(_ref) {var id = _ref.id,_ref$target = _ref.target,target = _ref$target === undefined ? 'projects' : _ref$target,_ref$includeDeleted = _ref.includeDeleted,includeDeleted = _ref$includeDeleted === undefined ? false : _ref$includeDeleted;return _axios2.default.get('/' + target + '/' + id + '?include_deleted=' + includeDeleted).
  then(receivePropertySuccess, receivePropertyFail);};

var fetchGetSimilarProperties = function fetchGetSimilarProperties(_ref2) {var property_id = _ref2.property_id;return _axios2.default.get('/properties/similar-properties/' + property_id).
  then(getSimilarPropertiesSuccess, getSimilarPropertiesFail);};

var submitProjectContactUsForm = function submitProjectContactUsForm(data) {return _axios2.default.post('/messaging/contact-project-owner', Object.assign({},
  data)).

  then(sendProjectContactUsFormSuccess).
  catch(sendProjectContactUsFormFail);};

var receiveHandler = function receiveHandler(state, payload) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    loaded: false,
    propertyId: null,
    data: null }),
  promise(fetchReceive, payload));};

var handleGetSimilarProperties = function handleGetSimilarProperties(state, payload) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    loaded: false,
    similarProperties: null }),
  promise(fetchGetSimilarProperties, payload));};

var receiveHandlerSuccess = function receiveHandlerSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    propertyId: action.data.id,
    data: action.data,
    messages: (0, _get2.default)(action.data, 'messages', []).reverse() });};


var receiveHandlerFail = function receiveHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while loading property details');

  error.status = action.response.status;

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    propertyId: null,
    data: null,
    error: error });

};

var handleGetSimilarPropertiesSuccess = function handleGetSimilarPropertiesSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    similarProperties: action.data });};


var handleGetSimilarPropertiesFail = function handleGetSimilarPropertiesFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while loading property details');

  error.status = action.response.status;

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    similarProperties: null,
    error: error });

};

var handleSendProjectContactUsForm = function handleSendProjectContactUsForm(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    formSubmitting: true }),
  promise(submitProjectContactUsForm, action));};

var handleSendProjectContactUsFormSuccess = function handleSendProjectContactUsFormSuccess(state) {return Object.assign({},
  state, {
    formSubmitting: false,
    formSubmitted: true,
    formError: null,
    isModalContactsOpen: false });};


var handleSendProjectContactUsFormFail = function handleSendProjectContactUsFormFail(state, _ref3) {var response = _ref3.response;return Object.assign({},
  state, {
    formSubmitting: false,
    formSubmitted: true,
    formError: response.data });};



var handleOpen = function handleOpen(state, preloadData) {return Object.assign({},
  state, {
    isDetailsModalOpen: true,
    data: null,
    propertyId: preloadData && preloadData.propertyId,
    preloadData: preloadData });};


var handleHide = function handleHide(state) {return Object.assign({},
  state, {
    isDetailsModalOpen: false,
    preloadData: null,
    propertyId: null,
    isPreview: false,
    loading: false,
    loaded: false,
    translatedDescriptionRequired: null,
    descriptionLoaded: false,
    translatedDescriptionText: null,
    showOriginalDescription: false,
    targetDescriptionLanguage: null,
    sourceDescriptionLanguage: null,
    translatedSummaryRequired: null,
    summaryLoaded: false,
    showOriginalSummary: false,
    translatedSummaryText: null,
    targetSummaryLanguage: null,
    sourceSummaryLanguage: null });};


var handleOpenLightbox = function handleOpenLightbox(state, imgIdx) {return Object.assign({},
  state, {
    isLightboxOpen: true,
    currentImage: imgIdx });};


var handleHideLightbox = function handleHideLightbox(state) {return Object.assign({},
  state, {
    isLightboxOpen: false });};


var handleChangeLightboxActiveSlide = function handleChangeLightboxActiveSlide(state, idx) {return Object.assign({},
  state, {
    currentImage: idx });};


var handleOpenModalContacts = function handleOpenModalContacts(state) {return Object.assign({},
  state, {
    isModalContactsOpen: true });};


var handleHideModalContacts = function handleHideModalContacts(state) {return Object.assign({},
  state, {
    isModalContactsOpen: false,
    isLightboxOpen: false });};


var handlePreviewOpen = function handlePreviewOpen(state, data) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    isDetailsModalOpen: true,
    isPreview: true,
    data: data });};


var handlePreviewHide = function handlePreviewHide(state) {return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    isDetailsModalOpen: false,
    isPreview: false,
    data: null });};


var detectDescriptionCall = function detectDescriptionCall(_ref4) {var q = _ref4.q,locale = _ref4.locale;return _services.TranslationService.
  suggestStringLanguage(q, 0.7).
  then(function (detection) {
    if (detection) {
      return {
        targetDescriptionLanguage: locale,
        sourceDescriptionLanguage: detection.language,
        translatedDescriptionRequired: detection.language !== locale };

    }

    return { translatedDescriptionRequired: false };
  }).
  then(detectDescriptionLanguageSuccess);};

var translateDescriptionCall = function translateDescriptionCall(_ref5) {var q = _ref5.q,targetDescriptionLanguage = _ref5.targetDescriptionLanguage,sourceDescriptionLanguage = _ref5.sourceDescriptionLanguage;return _services.TranslationService.
  translate(q, targetDescriptionLanguage, sourceDescriptionLanguage).
  then(translateDescriptionSuccess).
  catch(translateDescriptionFail);};

// .then((detection) => {
//   if (detection) {
//     return {
//       source: detection.language,
//       translatedDescriptionRequired: detection.language !== locale
//     };
//   }
//
//   return TranslationService.detect(q.split('')[0])
//     .then(({ data: { data: { detections } } }) => {
//       const clientLanguage = locale !== 'he' ? locale : 'iw';
//       return {
//         source: detections[0][0].language,
//         translatedDescriptionRequired: detections[0][0].language !== clientLanguage
//       };
//       // return resolve({ translatedDescriptionRequired, descriptionTranslated: true });
//     });
// })
// .then((translatedDescriptionRequired) => {
//   if (!translatedDescriptionRequired) {
//     return { translatedDescriptionRequired, descriptionTranslated: true };
//   }
//
//   const clientLanguage = locale !== 'he' ? locale : 'iw';
//
//   return TranslationService
//     .translate(q, clientLanguage, source)
//     .then(translatedDescriptionText => resolve({
//       translatedDescriptionRequired,
//       descriptionTranslated: true,
//       translatedDescriptionText
//     }));
// })

var handleTranslateDescription = function handleTranslateDescription(state, _ref6) {var q = _ref6.q;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    descriptionLoading: true }),
  promise(translateDescriptionCall, {
    q: q,
    targetDescriptionLanguage: state.targetDescriptionLanguage,
    sourceDescriptionLanguage: state.sourceDescriptionLanguage }));};


var handleTranslateDescriptionSuccess = function handleTranslateDescriptionSuccess(state, action) {return Object.assign({},
  state, {
    translatedDescriptionText: action,
    descriptionLoading: false,
    descriptionLoaded: true });};


var handleTranslateDescriptionFail = function handleTranslateDescriptionFail(state) {return Object.assign({},
  state, {
    translatedDescriptionRequired: false,
    descriptionLoaded: false,
    translatedDescriptionText: null,
    showOriginalDescription: false });};


var handleResetDescription = function handleResetDescription(state) {return Object.assign({},
  state, {
    translatedDescriptionRequired: null,
    descriptionLoaded: false,
    showOriginalDescription: false,
    translatedDescriptionText: null,
    targetDescriptionLanguage: null,
    sourceDescriptionLanguage: null,
    translatedSummaryRequired: null,
    summaryLoaded: false,
    showOriginalSummary: false,
    translatedSummaryText: null,
    targetSummaryLanguage: null,
    sourceSummaryLanguage: null });};


var handleToggleDescriptionTranslation = function handleToggleDescriptionTranslation(state) {return Object.assign({},
  state, {
    showOriginalDescription: !state.showOriginalDescription });};


var handleDetectDescriptionLanguage = function handleDetectDescriptionLanguage(state, action) {
  if (!action.q || !action.q.length) {
    return Object.assign({},
    state, {
      translatedDescriptionRequired: false,
      descriptionLoaded: false,
      translatedDescriptionText: null,
      showOriginalDescription: false });

  }

  return (0, _reduxLoop.loop)(state, promise(detectDescriptionCall, action));
};

var handleDetectDescriptionLanguageSuccess = function handleDetectDescriptionLanguageSuccess(state, action) {return Object.assign({},
  state,
  action);};


var detectSummaryTranslateCall = function detectSummaryTranslateCall(_ref7) {var q = _ref7.q,locale = _ref7.locale;return _services.TranslationService.
  suggestStringLanguage(q, 0.7).
  then(function (detection) {
    if (detection) {
      return {
        translatedSummaryRequired: detection.language !== locale,
        targetSummaryLanguage: locale,
        sourceSummaryLanguage: detection.language };

    }

    return {
      translatedSummaryRequired: false };

  }).
  then(detectSummaryLanguageSuccess);};

var handleDetectSummaryLanguage = function handleDetectSummaryLanguage(state, action) {
  if (!action.q || !action.q.length) {
    return Object.assign({},
    state, {
      translatedSummaryRequired: false,
      summaryLoaded: false,
      showOriginalSummary: false,
      translatedSummaryText: null });

  }

  return (0, _reduxLoop.loop)(state, promise(detectSummaryTranslateCall, action));
};

var handleDetectSummaryLanguageSuccess = function handleDetectSummaryLanguageSuccess(state, action) {return Object.assign({},
  state,
  action);};


var translateTextCall = function translateTextCall(_ref8) {var q = _ref8.q,targetSummaryLanguage = _ref8.targetSummaryLanguage,sourceSummaryLanguage = _ref8.sourceSummaryLanguage;return _services.TranslationService.
  translate(q, targetSummaryLanguage, sourceSummaryLanguage).
  then(translateSummarySuccess).
  catch(translateSummaryFail);};

var handleTranslateSummary = function handleTranslateSummary(state, _ref9) {var q = _ref9.q,field = _ref9.field;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    summaryLoading: true }),
  promise(translateTextCall, {
    q: q,
    targetSummaryLanguage: state.targetSummaryLanguage,
    sourceSummaryLanguage: state.sourceSummaryLanguage }));};


var handleTranslateSummarySuccess = function handleTranslateSummarySuccess(state, action) {return Object.assign({},
  state, {
    translatedSummaryText: action,
    summaryLoading: false,
    summaryLoaded: true });};


var handleTranslateSummaryFail = function handleTranslateSummaryFail(state, action) {return Object.assign({},
  state, {
    translatedSummaryRequired: false,
    summaryLoaded: false,
    translatedSummaryText: null,
    showOriginalSummary: false });};


var handleToggleSummaryTranslation = function handleToggleSummaryTranslation(state, action) {return Object.assign({},
  state, {
    showOriginalSummary: !state.showOriginalSummary });};


var sendReportProperty = function sendReportProperty(data) {return _axios2.default.post('/mailing/report_property', data).
  then(reportPropertySuccess, reportPropertyFail);};

var handleReportProperty = function handleReportProperty(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    reportSending: true }),
  promise(sendReportProperty, action));};

var handleReportPropertySuccess = function handleReportPropertySuccess(state) {return Object.assign({},
  state, {
    reportSending: false });};


var handleReportPropertyFail = function handleReportPropertyFail(state, error) {return {
    reportSending: false,
    reportSendingError: error };};


var handleSetPreloadData = function handleSetPreloadData(state, preloadData) {return Object.assign({},
  state, {
    preloadData: preloadData });};


var upsertMessage = function upsertMessage(_ref10) {var token = _ref10.token,id = _ref10.id,data = _objectWithoutProperties(_ref10, ['token', 'id']);
  if (!id) {
    return _axios2.default.
    post('projects/' + data.project_id + '/messages', data, { headers: { access_token: token } }).
    then(messageActionSuccess, messageActionFail);
  }

  return _axios2.default.
  put('projects/' + data.project_id + '/messages/' + id, Object.assign({}, data, { id: id }), { headers: { access_token: token } }).
  then(messageActionSuccess, messageActionFail);
};

var deleteMessage = function deleteMessage(_ref11) {var token = _ref11.token,data = _objectWithoutProperties(_ref11, ['token']);return _axios2.default.
  post('projects/' + data.project_id + '/messages/' + data.id + '/remove', data, { headers: { access_token: token } }).
  then(messageActionSuccess, messageActionFail);};

var upsertMessageHandler = function upsertMessageHandler(state, payload) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    messageSubmitting: true }),
  promise(upsertMessage, payload));};

var deleteMessageHandler = function deleteMessageHandler(state, payload) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    messageSubmitting: true }),
  promise(deleteMessage, payload));};

var successMassageHandler = function successMassageHandler(state, payload) {return Object.assign({},
  state, {
    messages: (0, _get2.default)(payload.data, 'messages', []).reverse(),
    messageSubmitting: false });};


var failMessageHandler = function failMessageHandler(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error message');

  error.status = action.response.status;

  return Object.assign({},
  state, {
    messageSubmitting: false,
    error: error });

};

var propertyDetails = (0, _reduxAct.createReducer)(function (on) {
  on(openPreviewDetailsPopup, handlePreviewOpen);
  on(hidePreviewDetailsPopup, handlePreviewHide);
  on(openDetailsPopup, handleOpen);
  on(hideDetailsPopup, handleHide);
  on(receiveProperty, receiveHandler);
  on(receivePropertySuccess, receiveHandlerSuccess);
  on(receivePropertyFail, receiveHandlerFail);
  on(openLightbox, handleOpenLightbox);
  on(hideLightbox, handleHideLightbox);
  on(changeLightboxActiveSlide, handleChangeLightboxActiveSlide);
  on(openModalContacts, handleOpenModalContacts);
  on(hideModalContacts, handleHideModalContacts);
  on(detectDescriptionLanguage, handleDetectDescriptionLanguage);
  on(detectDescriptionLanguageSuccess, handleDetectDescriptionLanguageSuccess);
  on(translateDescription, handleTranslateDescription);
  on(translateDescriptionSuccess, handleTranslateDescriptionSuccess);
  on(translateDescriptionFail, handleTranslateDescriptionFail);
  on(resetDescriptionTranslate, handleResetDescription);
  on(toggleDescriptionTranslation, handleToggleDescriptionTranslation);
  on(reportProperty, handleReportProperty);
  on(reportPropertySuccess, handleReportPropertySuccess);
  on(reportPropertyFail, handleReportPropertyFail);
  on(setPreloadData, handleSetPreloadData);
  on(sendProjectContactUsForm, handleSendProjectContactUsForm);
  on(sendProjectContactUsFormSuccess, handleSendProjectContactUsFormSuccess);
  on(sendProjectContactUsFormFail, handleSendProjectContactUsFormFail);
  on(upsertMessageAction, upsertMessageHandler);
  on(deleteMessageAction, deleteMessageHandler);
  on(messageActionSuccess, successMassageHandler);
  on(messageActionFail, failMessageHandler);
  on(detectSummaryLanguage, handleDetectSummaryLanguage);
  on(detectSummaryLanguageSuccess, handleDetectSummaryLanguageSuccess);
  on(translateSummary, handleTranslateSummary);
  on(translateSummarySuccess, handleTranslateSummarySuccess);
  on(translateSummaryFail, handleTranslateSummaryFail);
  on(toggleSummaryTranslation, handleToggleSummaryTranslation);
  on(getSimilarProperties, handleGetSimilarProperties);
  on(getSimilarPropertiesSuccess, handleGetSimilarPropertiesSuccess);
  on(getSimilarPropertiesFail, handleGetSimilarPropertiesFail);
}, initialState);exports.


openDetailsPopup = openDetailsPopup;exports.
hideDetailsPopup = hideDetailsPopup;exports.
receiveProperty = receiveProperty;exports.
openLightbox = openLightbox;exports.
hideLightbox = hideLightbox;exports.
changeLightboxActiveSlide = changeLightboxActiveSlide;exports.
openModalContacts = openModalContacts;exports.
hideModalContacts = hideModalContacts;exports.
openPreviewDetailsPopup = openPreviewDetailsPopup;exports.
hidePreviewDetailsPopup = hidePreviewDetailsPopup;exports.
translateDescription = translateDescription;exports.
resetDescriptionTranslate = resetDescriptionTranslate;exports.
toggleDescriptionTranslation = toggleDescriptionTranslation;exports.
detectDescriptionLanguage = detectDescriptionLanguage;exports.
reportProperty = reportProperty;exports.
setPreloadData = setPreloadData;exports.
sendProjectContactUsForm = sendProjectContactUsForm;exports.
upsertMessageAction = upsertMessageAction;exports.
deleteMessageAction = deleteMessageAction;exports.
translateSummary = translateSummary;exports.
detectSummaryLanguage = detectSummaryLanguage;exports.
toggleSummaryTranslation = toggleSummaryTranslation;exports.
getSimilarProperties = getSimilarProperties;exports.default =


propertyDetails;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/propertyDetails.js
// module id = 49
// module chunks = 0